<template>
  <div class="couponMb botPage">
    <mbHeader :title="$t('coupon')" :left="true" :lang="true"></mbHeader>
    <coupon></coupon>
  </div>
</template>

<script>
import mbHeader from "../../components/mobile/mbHeader";
import coupon from '../Profile/coupon';
export default {
  name: "mobileCoupon",
  components: {coupon,mbHeader},
}
</script>

<style scoped lang="less">
.couponMb {
  min-height: 100vh;
  padding: 50px 0 16px;
  background-color: rgba(0, 0, 0, 0.02);
}
</style>



// WEBPACK FOOTER //
// src/view/mobile/mobileCoupon.vue